import RefundRoute from './Refund';
import OrderRoute from './Order';

export default () => ({
	path: 'service',
	indexRoute: {
		component: null,
	},
	childRoutes: [RefundRoute(), OrderRoute()],
});
